import React from 'react';
import { motion } from 'framer-motion';
import { WaveDivider } from './WaveDivider';
export function Proof() {
  return <section className="bg-[#111] py-24 relative overflow-hidden" data-id="element-137">
      <div className="absolute top-0 left-0 w-full text-[#0a0a0a]" data-id="element-138">
        <WaveDivider className="h-8 md:h-12 rotate-180" data-id="element-139" />
      </div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-141">
          <svg className="w-12 h-12 text-[#d4a437]/40 mx-auto mb-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-142">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-143" />
          </svg>

          <p className="text-xl md:text-3xl font-serif italic text-white leading-relaxed mb-8" data-id="element-144">
            "Este sistema no es una teoría; es una necesidad adaptada a la
            realidad actual. Al aprender de Gus Sevilla, estás adoptando el
            criterio de un operador que sabe que la eficiencia y la seguridad
            van de la mano. No improvisas con tu seguridad; construyes con
            estructura."
          </p>

          <div className="inline-flex items-center justify-center" data-id="element-145">
            <div className="w-12 h-1 bg-[#d4a437] mr-4 rounded-full" data-id="element-146"></div>
            <span className="text-neutral-400 font-medium uppercase tracking-wider text-sm" data-id="element-147">
              Gus Sevilla
            </span>
            <div className="w-12 h-1 bg-[#d4a437] ml-4 rounded-full" data-id="element-148"></div>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 w-full text-[#0a0a0a]" data-id="element-149">
        <WaveDivider className="h-8 md:h-12" data-id="element-150" />
      </div>
    </section>;
}